export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14661.a6fe3070.jpg";